import type { ComponentProps } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { EntityAboutCard } from '@backstage/plugin-catalog';

// CR-1115: hide the "Edit" (pencil) IconButton on EntityAboutCard.
// Users should not be redirected to catalog-info.yaml on GitHub from the UI;
// catalog changes go through the catalog automation PR flow.
const useStyles = makeStyles({
  root: {
    display: 'contents',
    '& [aria-label="Edit"]': {
      display: 'none',
    },
  },
});

type Props = ComponentProps<typeof EntityAboutCard>;

export const CustomAboutCard = (props: Props) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <EntityAboutCard {...props} />
    </div>
  );
};
